import http from "@/common/http"

export const detail = (code,city) =>{
  return http({
    url:"/cont/promotion/detail",
    method:'get',
    data:{
      code
    }
  },'',false)
}

export const list = (data) =>{
  return http({
    url:"/cont/promotion/list",
    method:'post',
    data:data
  })
}

export default {
  detail,
  list
}



// WEBPACK FOOTER //
// ./src/services/client/cont/promotion.js